import Tab from './Tab';
import { Row } from './style';
const tabs = {
  1: 'EXPERIENCE',
  2: 'EDUCATION'
};
const Tabs = ({ activeTab, setActiveTab }) => {
  return (
    <Row>
      {Object.keys(tabs).map((key) => {
        return (
          <Tab
            key={key}
            keyId={key}
            label={tabs[key]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        );
      })}
    </Row>
  );
};

export default Tabs;
